//Services
import { format } from 'svelte-i18n';
//Svelte methods
import { get } from 'svelte/store';
import { mobile } from 'src/services/mobile-rework';
//Design system components
import { toast } from '@Shelly/shelly-design-system';

export function copy(msg: string, toast_msg: string) {
	if (navigator.clipboard && window.isSecureContext && (!mobile.isMobile || mobile.OS !== 'Android')) {
		navigator.clipboard
			.writeText(msg)
			.then(() => {
				toast.open({
					type: 'success',
					title: get(format)(toast_msg, { default: toast_msg }),
				});
			})
			.catch(() => {
				toast.open({
					type: 'danger',
					title: get(format)('error_global', {
						default: 'Something went wrong!',
					}),
				});
			});
	} else {
		let textArea = document.createElement('textarea');
		textArea.value = msg;
		textArea.style.position = 'absolute';
		textArea.style.opacity = '0';
		document.body.appendChild(textArea);
		textArea.select();
		if (document.execCommand('copy')) {
			toast.open({ type: 'success', title: toast_msg });
		} else {
			toast.open({ type: 'danger', title: get(format)('error_global') });
		}
		textArea.remove();
	}
}
